import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { authToken } from '../../scripts/authentication.script';

export class RecurringContractDA {
  static apiResponse: ApiResponse

  public static async getRecurringContracts(
    id_company: string,
    status: string,
    id_contact: string,
    sort_field: string,
    sort_mode: string,
    page: number = 1,
    limit: number = 20,
    search: string = ''
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/recurring-contracts?status=${status}&id_contact=${id_contact}&sort_by=${sort_field}&sort_order=${sort_mode}&page=${page}&limit=${limit}${search ? `&search=${encodeURIComponent(search)}` : ''}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async getRecurringContract(
    id_company: string,
    id_recurring_contract: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/recurring-contracts/${id_recurring_contract}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async postRecurringContract(
    id_company: string,
    data: any
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/recurring-contracts`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.post(url, data, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async putRecurringContract(
    id_company: string,
    id_recurring_contract: string,
    data: any
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/recurring-contracts/${id_recurring_contract}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.put(url, data, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async putRecurringContractStatus(
    id_company: string,
    id_recurring_contract: string,
    new_status: string
  ): Promise<ApiResponse> {
    const actionByStatus: Record<string, string> = {
      ended: 'end',
      paused: 'pause',
      active: 'resume',
    }
    const action = actionByStatus[new_status]

    if (!action) {
      this.apiResponse = {
        status: 400,
        message: 'Invalid status transition',
        data: { code: 'INVALID_STATUS', message: `Statut non géré: ${new_status}` }
      }
      return this.apiResponse
    }

    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/recurring-contracts/${id_recurring_contract}/${action}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.patch(url, {}, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async deleteRecurringContract(
    id_company: string,
    id_recurring_contract: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/recurring-contracts/${id_recurring_contract}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.delete(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async renewRecurringContract(
    id_company: string,
    id_contract: string,
    note?: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/recurring-contracts/${id_contract}/renew`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.patch(url, note ? { note } : {}, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async receiveDeposit(
    id_company: string,
    id_contract: string,
    data: { amount: number, date: string, id_treasury_account: string, method?: string, note?: string }
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/recurring-contracts/${id_contract}/deposit/receive`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.patch(url, data, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async returnDeposit(
    id_company: string,
    id_contract: string,
    data: { retained_amount?: number, date: string, id_treasury_account: string, note?: string }
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/recurring-contracts/${id_contract}/deposit/return`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.patch(url, data, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async generateInvoice(
    id_company: string,
    id_recurring_contract: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/recurring-contracts/${id_recurring_contract}/generate`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.post(url, null, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }
}
